import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import AcaoForm from "../../../components/forms/AcaoForm.vue";
import { AcaoService } from "../../../services/AcaoService";

export default {
    name: "CriarAcao",
    components: {
        Breadcrumb,
        AcaoForm
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: "Início",
                    disabled: false,
                    href: "/"
                },
                {
                    text: "Ações",
                    disabled: false,
                    href: "/acoes"
                },
                {
                    text: "Criar Ação",
                    disabled: true,
                    href: "/acoes/criar"
                }
            ]
        };
    },
    methods: {
        async handleSave(formData) {
            try {
                const response = await AcaoService.criarAcao(formData);
                
                if (response.success) {
                    // Redirecionar para a lista de ações após salvar
                    this.$router.push('/gerenciar-acoes');
                } else {
                    throw new Error(response.message || 'Erro ao criar ação');
                }
            } catch (error) {
                console.error('Erro ao criar ação:', error);
                // O componente AcaoForm já trata a exibição de mensagens de erro
                throw error;
            }
        },
        handleCancel() {
            // Retornar para a tela principal do menu
            this.$router.push('/gerenciar-acoes');
        }
    }
};
